import { render, staticRenderFns } from "./SedanIcon.vue?vue&type=template&id=38ddfa8a&"
import script from "./SedanIcon.vue?vue&type=script&lang=js&"
export * from "./SedanIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports